import { formatDate } from '../../../utility/dateUtils';

export const CANDIDATE_PROFILE_INFO = {
  CV: 'cv',
  EDUCATION: 'education',
  EXPERIENCE: 'experience',
  SKILLS: 'skills',
  CONTACT_DETAILS: 'contact_details',
  DATE_OF_BIRTH: 'date_of_birth',
  PROFESSION_TITLE: 'profession_title',
  REFERRAL: 'referral',
};

const MONTH_FORMAT = 'MMMM';

export const getPeriod = info => {
  const dateFrom =
    info.start_year && info.start_month
      ? `${formatDate(
          new Date(info.start_year, info.start_month - 1, 1),
          MONTH_FORMAT
        )} ${info.start_year}`
      : info.start_year;
  let dateTo = info.end_year ? info.end_year : 'Present';
  dateTo =
    info.end_year && info.end_month
      ? `${formatDate(
          new Date(info.end_year, info.end_month - 1, 1),
          MONTH_FORMAT
        )} ${info.end_year}`
      : dateTo;
  return `${dateFrom} - ${dateTo}`;
};
